module.exports = __webpack_public_path__ + "static/img/industries5.8a4c3bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industries5.png
// module id = 5J6C
// module chunks = 1